import VehicleIcon from '@mui/icons-material/DirectionsCar';
import Tag from '.';

const Vehicle = () => (
  <Tag style={{ boxShadow: 'none', padding: 0 }}>
    <VehicleIcon style={{ width: '16px', height: '16px' }} />
  </Tag>
);

export default Vehicle;
